import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { FilesUIProvider } from './FilesContextProvider';

const FilesList = React.lazy(() => import('./Files'));

function RecordedVideos(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>ویدیوهای ضبط شده</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <FilesUIProvider>
          <FilesList {...props} />
        </FilesUIProvider>
      </Suspense>
    </Page>
  );
}

export default RecordedVideos;
